<article class="mb-[12.8rem] flex flex-col">
  <app-breadcrumb [items]="['FAQ']"></app-breadcrumb>

  <section class="px-[7rem] sm:px-[9.6rem] flex flex-col gap-[3.2rem]" aria-labelledby="faq-heading">
    <h1 id="faq-heading" class="dsr-typescale-title-medium">FAQ</h1>

    <div class="flex flex-col sm:gap-[3.2rem] gap-[5.2rem]">
      <section class="flex flex-col gap-[1.6rem]" aria-labelledby="faq-q1">
        <h3 id="faq-q1" class="dsr-typescale-title-small !uppercase">
          {{ "FAQ_QUESTION1" | translate }}
        </h3>

        <div class="w-fit sm:h-[4.8rem]">
          <a href="https://newdialogys.renault.com/" class="dsr-hyperlink" target="_blank" rel="noopener noreferrer"
            aria-label="New Dialogys Portal (opens in new tab)">
            <button mat-flat-button class="" type="button">
              <span class="">{{ "ND_PORTAL" | translate }}</span>
              <dsr-icon name="link-out" class="!size-[1rem] sm:!size-[2.4rem]" color="white"
                aria-hidden="true"></dsr-icon>
            </button>
          </a>
        </div>
      </section>
      
      <section class="flex flex-col gap-[1.6rem]" aria-labelledby="faq-q2">
        <h3 id="faq-q2" class="dsr-typescale-title-small !uppercase">
          {{ "FAQ_QUESTION2" | translate }}
        </h3>
        <span class="dsr-typescale-body-small">
          {{ ("FORGOT_PASSWORD_DESCRIPTION" | translate).split("webmaster.infotech@renault.com")[0] }}
          <a aria-label="Contact support via email" href="mailto:webmaster.infotech@renault.com"><span
              class="!font-[600] dsr-typescale-body-small border-dotted border-b-2">webmaster.infotech&#64;renault.com</span></a>
          {{ ("FORGOT_PASSWORD_DESCRIPTION" | translate).split("webmaster.infotech@renault.com")[1] }}.
        </span>
      </section>

      <section class="flex flex-col gap-[1.6rem]" aria-labelledby="faq-q3">
        <h3 id="faq-q3" class="dsr-typescale-title-small !uppercase">
          {{ "FAQ_QUESTION3" | translate }}
        </h3>

        <div>
          <ol class="list-decimal list-inside">
            <li class="dsr-typescale-body-small">
              {{ "VAT_CODE_DESC1_LABEL_BIS" | translate }}
              <a target="_blank" href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation"
                aria-label="EU VAT validation website (opens in new tab)" class="dsr-hyperlink">
                <span class="border-dotted border-b-2 dsr-typescale-body-small">https://ec.europa.eu/taxation_customs/vies/#/vat-validation</span>
              </a>
            </li>
            <li class="dsr-typescale-body-small">
              {{ "VAT_CODE_DESC2_LABEL_BIS" | translate }}
            </li>
          </ol>
          <span class="dsr-typescale-body-small">
            {{ "VAT_CODE_EX_LABEL" | translate }}
          </span>
        </div>
      </section>

      <section class="flex flex-col gap-[1.6rem]" aria-labelledby="faq-q4">
        <h3 id="faq-q4" class="dsr-typescale-title-small !uppercase">
          {{ "FAQ_QUESTION4" | translate }}
        </h3>

        <span class="dsr-typescale-body-small">
          {{ ("FORGOT_PASSWORD_DESCRIPTION" | translate).split("webmaster.infotech@renault.com")[0] }}
          <a aria-label="Contact support via email" href="mailto:webmaster.infotech@renault.com" class="dsr-hyperlink">
            <span class="!font-[600] dsr-typescale-body-small border-dotted border-b-2">webmaster.infotech&#64;renault.com</span>
          </a>
          {{ ("FORGOT_PASSWORD_DESCRIPTION" | translate).split("webmaster.infotech@renault.com")[1] }}.
        </span>
      </section>

      @if(isAuthenticated()) {
        @for (file of getFaqHelpDocs(); track file) {
          <div>
            <app-file-download [file]="file"></app-file-download>
          </div>
        }
      }
    </div>
  </section>
</article>